export const PASSWORD_RULES = [
  { key: 'characters', label: 'At least 8 characters' },
  { key: 'capitalLetter', label: 'At least one upper case letter' },
  { key: 'lowercaseLetter', label: 'At least one lower case letter' },
  { key: 'symbol', label: 'At least one symbol' },
  { key: 'numbers', label: 'At least one number' },
];
